import { c as _c } from "react/compiler-runtime";
import { DEFAULT_SIZE_UNIT, getSizeRangeFilterId, parseSizeRangeFilterId } from "@components/projects/projects-filters/projects-size-filter-utils";
import { SizeLimitField } from "@components/projects/projects-filters/size-filter/size-limit-field";
import { FilterChipDropdownBackHeader } from "@components/common/faro-table/faro-table-filter/filter-chip-dropdown-back-header";
import { Button, Text } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { useState } from "react";
/** The fields to type the limits of a custom size range in, shown in the dropdown of the size chip */
export function SizeCustomRange(t0) {
  const $ = _c(38);
  const {
    activeRange,
    onBack,
    onCancel,
    onApply
  } = t0;
  let t1;
  if ($[0] !== activeRange?.min) {
    t1 = () => toLimitInput(activeRange?.min);
    $[0] = activeRange?.min;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [min, setMin] = useState(t1);
  let t2;
  if ($[2] !== activeRange?.max) {
    t2 = () => toLimitInput(activeRange?.max);
    $[2] = activeRange?.max;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [max, setMax] = useState(t2);
  let range;
  let t3;
  if ($[4] !== max || $[5] !== min) {
    range = toSizeRange(min, max);
    t3 = range !== undefined && parseSizeRangeFilterId(getSizeRangeFilterId(range)) === undefined;
    $[4] = max;
    $[5] = min;
    $[6] = range;
    $[7] = t3;
  } else {
    range = $[6];
    t3 = $[7];
  }
  const isReversed = t3;
  const canApply = range ? !isReversed : activeRange !== undefined;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      px: 2,
      py: 1,
      gap: 1.5
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== onBack) {
    t5 = <FilterChipDropdownBackHeader title="Custom range" backLabel="Back to the sizes" onBack={onBack} />;
    $[9] = onBack;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== min) {
    t6 = <SizeLimitField label="Min" limit={min} onLimitChange={setMin} />;
    $[11] = min;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== max) {
    t7 = <SizeLimitField label="Max" limit={max} onLimitChange={setMax} />;
    $[13] = max;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = isReversed ? "error.main" : "text.secondary";
  let t9;
  if ($[15] !== t8) {
    t9 = {
      color: t8
    };
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = isReversed ? "The minimum must not be larger than the maximum." : "Sizes include both limits. Leave a field empty for no limit.";
  let t11;
  if ($[17] !== t10 || $[18] !== t9) {
    t11 = <Text variant="bodyS" sx={t9}>{t10}</Text>;
    $[17] = t10;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      justifyContent: "flex-end",
      gap: 1
    };
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== onCancel) {
    t13 = <Button variant="secondary" onClick={onCancel}>Cancel</Button>;
    $[21] = onCancel;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  const t14 = !canApply;
  let t15;
  if ($[23] !== onApply || $[24] !== range) {
    t15 = () => onApply(range);
    $[23] = onApply;
    $[24] = range;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t14 || $[27] !== t15) {
    t16 = <Button variant="primary" disabled={t14} onClick={t15}>Apply</Button>;
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t13 || $[30] !== t16) {
    t17 = <Stack direction="row" sx={t12}>{t13}{t16}</Stack>;
    $[29] = t13;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t11 || $[33] !== t17 || $[34] !== t5 || $[35] !== t6 || $[36] !== t7) {
    t18 = <Stack sx={t4} onKeyDown={_temp}>{t5}{t6}{t7}{t11}{t17}</Stack>;
    $[32] = t11;
    $[33] = t17;
    $[34] = t5;
    $[35] = t6;
    $[36] = t7;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  return t18;
}

/** Returns the limit as the field shows it, which is empty with the default unit for no limit */
function _temp(event) {
  return event.stopPropagation();
}
function toLimitInput(limit) {
  return limit ?? {
    value: null,
    unit: DEFAULT_SIZE_UNIT
  };
}

/** Returns the range of the typed limits, or undefined if both fields are empty */
function toSizeRange(min, max) {
  const range = {
    min: toSizeLimit(min),
    max: toSizeLimit(max)
  };
  return range.min || range.max ? range : undefined;
}

/** Returns the typed limit, or undefined if its field is empty */
function toSizeLimit({
  value,
  unit
}) {
  return value === null ? undefined : {
    value,
    unit
  };
}